<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">" {{ editedEntity.assetGroupCategory.name | translate }} - {{ editedEntity.assetGroup.name | translate }} " {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <b-form-tags v-model="form.products" size="lg" class="mb-2" add-on-change no-outer-focus>
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="['DDO', 'BGYS']">
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value=""> {{ $t("product.text") }}</option>
            </template>
          </b-form-select>

          <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
            </li>
          </ul>
        </template>
      </b-form-tags>

      <filter-select
        class="mt-4"
        id="asset-group-category-asset-group-asset-group-category-filter"
        ref="asset-group-category-asset-group-asset-group-category-filter"
        :placeholder="$t('asset-group-category.text')"
        :multiple="true"
        :displayCount="3"
        :isValid="!$v.form.assetGroupCategory.$invalid"
        @filter="onAssetGroupCategorySearch"
        :selected="form.assetGroupCategory"
        @changed="assetGroupCategorySelect"
        track="_id"
      />
      <filter-select
        class="mt-4"
        id="assetGroupFilter"
        ref="assetGroupFilter"
        :placeholder="$t('asset-group.text')"
        :multiple="true"
        :displayCount="3"
        :isValid="!$v.form.assetGroup.$invalid"
        @filter="onAssetGroupSearch"
        :selected="form.assetGroup"
        @changed="assetGroupSelect"
        track="_id"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "assetGroupCategoryAssetGroup";

export default {
  props: ["state"],
  data() {
    return {
      form: { products: [], assetGroupCategory: undefined, assetGroup: undefined },
    };
  },
  validations: {
    form: {
      assetGroupCategory: {
        required,
      },
      assetGroup: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceAssetGroupCategoryAssetGroup";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const assetGroupCategories = this.form.assetGroupCategory;
      const childAssetGroups = this.form.assetGroup;
      const _id = this.form._id;

      this.$emit("onSave", _id, this.form.products, assetGroupCategories, childAssetGroups);
    },

    async onAssetGroupCategorySearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceAssetGroupCategory" : "managementAssetGroupCategory";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout ? { "scope.value": { value: "system", isObject: true } } : {}) },
      });
      callback(response.data?.docs ?? []);
    },
    assetGroupCategorySelect(item) {
      this.form = { ...this.form, assetGroupCategory: item };
    },
    async onAssetGroupSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceAssetGroup" : "managementAssetGroup";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout ? { "scope.value": { value: "system", isObject: true } } : {}) },
      });
      callback(response.data?.docs ?? []);
    },
    assetGroupSelect(item) {
      this.form = { ...this.form, assetGroup: item };
    },
  },
};
</script>
